import { render, staticRenderFns } from "./Estudiantes-mod.vue?vue&type=template&id=dbfbea56"
import script from "./Estudiantes-mod.vue?vue&type=script&lang=js"
export * from "./Estudiantes-mod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports